<template lang='pug'>
  .fpui-helper-popover.pointer
    v-popover(:placement="position" trigger="hover" :autoHide="true")
      i.fpui.fpui-ask.tooltip-target(:class='className')
      template(slot="popover")
        slot
</template>

<script>

export default {
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    position: {
      type: String,
      default: 'right-end'
    }
  },
  computed: {
    className () {
      let className = [`text-${this.color}`]
      return className.join(' ')
    }
  }
}
</script>

<style lang='less'>
.fpui-helper-popover {
  display: inline-block;
  margin-left: 10px;
  .trigger {
    outline: none !important;
  }
}
</style>